export default "__VITE_ASSET__BPga4XOL__ 57w";